import React from 'react';
import * as FiIcons from 'react-icons/fi';

/**
 * PWA install card (full-live-cutover §3). Real beforeinstallprompt wiring
 * (usePwaInstall): when the browser offers install, this is a working
 * action; otherwise it renders the honest explanation — no service worker
 * ships yet, so the criteria may not be met everywhere.
 */
function InstallPromptCard({ canInstall, onInstall }) {
  return (
    <section className="settings-install-card">
      <span className="settings-install-icon"><FiIcons.FiDownload /></span>
      <div>
        <strong>Install the dashboard</strong>
        <span>
          {canInstall
            ? 'Your browser can install this app to your desktop or home screen.'
            : 'Install is available when your browser offers it (a service worker and manifest land with the PWA task) — the button appears automatically then.'}
        </span>
      </div>
      {canInstall ? (
        <button className="primary-button" onClick={onInstall} type="button">
          <FiIcons.FiDownload /> Install app
        </button>
      ) : (
        <button className="ghost-button" disabled title="Install not offered by this browser yet" type="button">
          Not offered yet
        </button>
      )}
    </section>
  );
}

export default InstallPromptCard;
